import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import { renderField } from '../../Inputs';
import Progress from '../../Progress';


const validate = (valueSet) => {
  const values = valueSet;
  const errors = { assessment: {} };

  if (!values.assessment) values.assessment = {};
  if (!values.assessment.activity_times) errors.assessment.activity_times = 'Please enter your activity level';
  if (!values.pathway_activity) errors.pathway_activity = 'Please enter if you\'d like help with this';

  return errors;
};

class WeeklyActivityLevel extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Row setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Progress step="activity" />
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="100" height="100" />
        </Paragraph>
        <Heading classes="header-text green" center><span id="register5">GET ACTIVE</span></Heading>
        <Paragraph classes="description" center>One of the best things we can do to stay healthy is to be active.</Paragraph>
        <Paragraph classes="section-text" center><strong>In the past week how many days have you been physically active for a total of 30 minutes of more?</strong></Paragraph>
        <form onSubmit={handleSubmit} className="form-register">
          <Field name="assessment[activity_times]" type="radiogroup" params={{ dataKey: 'numDaysWeek', name: 'assessment[activity_times]' }} component={renderField} centered />
          <Paragraph classes="section-text" center><strong>Would you like support to get more active?</strong></Paragraph>
          <Field name="pathway_activity" type="radiogroup" params={{ dataKey: 'LeaveMessage', classes: 'textUppercase' }} component={renderField} centered />
          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={this.props.previousPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

WeeklyActivityLevel.propTypes = {
  previousPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(WeeklyActivityLevel);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/WeeklyActivityLevel.jsx